<div class="page-title">{{view.getEntityBaseName(true)}}</div>
<ul class="breadcrumb">
  <li><a [routerLink]="['/home']"><span class="color-soft-grey-axial">{{'general.breadcrumb.you_are' | translate}}
      </span>{{'general.breadcrumb.home' | translate}}</a></li>
  <li *ngIf="organization != null"><i class="pi pi-angle-right"></i></li>
  <li *ngIf="organization != null"><a [routerLink]="['/organizations/0',organization.id]">{{organization.name}}</a></li>
  <li><i class="pi pi-angle-right"></i></li>
  <li *ngIf="view"><a [routerLink]="['/contacts']">{{view.getEntityBaseName(true)}}</a></li>
</ul>
<app-view #view [code]="'contacts.list'" [model]="contactsFilters" (onEvent)="onEvent($event)"></app-view>